import { render, staticRenderFns } from "./primaryTextbook.vue?vue&type=template&id=5903a380&scoped=true&"
import script from "./primaryTextbook.vue?vue&type=script&lang=js&"
export * from "./primaryTextbook.vue?vue&type=script&lang=js&"
import style0 from "./primaryTextbook.vue?vue&type=style&index=0&id=5903a380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903a380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VContainer,VFlex,VLayout,VStepper,VStepperContent,VStepperStep})
